// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file accounts/accounts_pl.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PLItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.AccountsPLRequest
 */
export class AccountsPLRequest extends Message<AccountsPLRequest> {
  /**
   * Start date for the report
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * End date for the report
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  /**
   * Whether to calculate moving average
   *
   * @generated from field: bool calculate_moving_average = 3;
   */
  calculateMovingAverage = false;

  /**
   * Period for moving average calculation
   *
   * @generated from field: int32 moving_average_period = 4;
   */
  movingAveragePeriod = 0;

  constructor(data?: PartialMessage<AccountsPLRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsPLRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "calculate_moving_average", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "moving_average_period", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsPLRequest {
    return new AccountsPLRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsPLRequest {
    return new AccountsPLRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsPLRequest {
    return new AccountsPLRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsPLRequest | PlainMessage<AccountsPLRequest> | undefined, b: AccountsPLRequest | PlainMessage<AccountsPLRequest> | undefined): boolean {
    return proto3.util.equals(AccountsPLRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.AccountsPLResponse
 */
export class AccountsPLResponse extends Message<AccountsPLResponse> {
  /**
   * List of profit and loss items
   *
   * @generated from field: repeated com.neulink.pharmacy.PLItem pl_items = 1;
   */
  plItems: PLItem[] = [];

  constructor(data?: PartialMessage<AccountsPLResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsPLResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pl_items", kind: "message", T: PLItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsPLResponse {
    return new AccountsPLResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsPLResponse {
    return new AccountsPLResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsPLResponse {
    return new AccountsPLResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsPLResponse | PlainMessage<AccountsPLResponse> | undefined, b: AccountsPLResponse | PlainMessage<AccountsPLResponse> | undefined): boolean {
    return proto3.util.equals(AccountsPLResponse, a, b);
  }
}

